import AnnouncementSettings from './AnnouncementSettings';

export default AnnouncementSettings;
